document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.custom-header-section');

    /* === menu-features-collection === B */

    // Init features collection menu Swiper
    const swiperContainer = header && header.querySelector('.custom-mega-menu-features__collection-swiper');
    const prevButton = header && header.querySelector('.custom-mega-menu-features__collection-swiper-button-prev');
    const nextButton = header && header.querySelector('.custom-mega-menu-features__collection-swiper-button-next');

    if (swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    slidesPerGroup: 4,
                },
                1201: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
            },
        });
    }

    // align collection item content height to max height
    function setMaxItemHeight(section, itemSelector, cssVarName) {
      if (!section) return;
      const items = section.querySelectorAll(itemSelector);
      if (!items.length) return;
      let maxH = 0;
      items.forEach(el => {
        const h = el.offsetHeight;
        if (h > maxH) maxH = h;
      });
      items.forEach(el => {
        el.style.setProperty(cssVarName, maxH + 'px');
      });
    }

    function setMaxCollectionImageHeight() {
      if (!header) return;

      const imageContainers = header.querySelectorAll('.custom-mega-menu-features__collection-item-image');
      if (!imageContainers.length) return;

      imageContainers.forEach((container) => {
        container.style.removeProperty('--max-collection-image-height');
      });

      let maxH = 0;
      imageContainers.forEach((container) => {
        const h = container.offsetHeight;
        if (h > maxH) maxH = h;
      });

      if (!maxH) return;

      imageContainers.forEach((container) => {
        container.style.setProperty('--max-collection-image-height', maxH + 'px');
      });
    }

    setMaxCollectionImageHeight();

    const collectionImages = header && header.querySelectorAll('.custom-mega-menu-features__collection-item-image img');

    if (window.IntersectionObserver && swiperContainer) {
      const collectionImageVisibilityObserver = new IntersectionObserver(setMaxCollectionImageHeight);
      collectionImageVisibilityObserver.observe(swiperContainer);
    }

    collectionImages && collectionImages.forEach((image) => {
      image.addEventListener('load', setMaxCollectionImageHeight, { once: true });
    });

    window.addEventListener('resize', setMaxCollectionImageHeight);
    window.addEventListener('load', setMaxCollectionImageHeight);
    setMaxItemHeight(header, '.custom-mega-menu-features__collection-item-content', '--max-item-content-height');
    /* === menu-features-collection === E */

    /* === menu-grid-items === B */
    setMaxItemHeight(header, '.custom-mega-menu-grid__item-content', '--max-item-content-height');
    /* === menu-grid-items === E */

    /* === mobile-menu-drawer === B */
    const openButton = header && header.querySelector('.custom-mobile-menu-drawer__open');
    const closeButton = header && header.querySelector('.custom-mobile-menu-drawer__close');
    const drawerCloseHelper = header && header.querySelector('.custom-mobile-menu-drawer__close-helper');
    const mobileDrawer = header && header.querySelector('.custom-header-mobile__drawer');

    function initMobileDrawer() {
        if (!openButton || !closeButton || !mobileDrawer) {
            return;
        }

        const syncDrawerTriggerState = function () {
            const isOpen = document.body.classList.contains('js-drawer-open-left');
            openButton.setAttribute('aria-expanded', String(isOpen));
            closeButton.setAttribute('aria-hidden', String(!isOpen));
            closeButton.tabIndex = isOpen ? 0 : -1;
        };

        openButton.addEventListener('click', function (event) {
            event.preventDefault();
            mobileDrawer.setAttribute('open', '');
        });

        const triggers = header.querySelectorAll('.custom-mobile-nav__item');
        const drawers = header.querySelectorAll('.custom-mobile-drawer__sublist');
        const backDrawerBtns = header.querySelectorAll('.custom-mobile-drawer__back');

        function closeAllDrawers() {
            drawers.forEach((drawer) => {
                drawer.removeAttribute('open');
            });
        }

        closeButton.addEventListener('click', function (event) {
            event.preventDefault();

            if (drawerCloseHelper) {
                drawerCloseHelper.click();
                closeAllDrawers();
                mobileDrawer.removeAttribute('open');
            } else {
                document.body.classList.remove('js-drawer-open');
                document.body.classList.remove('js-drawer-open-left');
            }

            syncDrawerTriggerState();
        });

        const bodyClassObserver = new MutationObserver(syncDrawerTriggerState);
        bodyClassObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class'],
        });

        syncDrawerTriggerState();

        function isMatchingDrawer(drawer, firstId, secondId) {
            const drawerFirstId = drawer.getAttribute('data-contain-first-id');
            const drawerSecondId = drawer.getAttribute('data-contain-second-id');

            return (firstId && drawerFirstId === firstId) || (secondId && drawerSecondId === secondId);
        }

        function isFirstLevelDrawer(drawer) {
            return !!drawer.getAttribute('data-contain-first-id');
        }

        function isSecondLevelDrawer(drawer) {
            return !!drawer.getAttribute('data-contain-second-id');
        }

        triggers.forEach((trigger) => {
            const firstTriggerId = trigger.getAttribute('data-contain-first-id');
            const secondTriggerId = trigger.getAttribute('data-contain-second-id');

            if (!firstTriggerId && !secondTriggerId) {
                return;
            }

            trigger.addEventListener('click', function (event) {
                event.preventDefault();

                drawers.forEach((drawer) => {
                    const shouldResetDrawer = secondTriggerId ? isSecondLevelDrawer(drawer) : isFirstLevelDrawer(drawer) || isSecondLevelDrawer(drawer);

                    if (shouldResetDrawer) {
                        drawer.removeAttribute('open');
                    }

                    if (isMatchingDrawer(drawer, firstTriggerId, secondTriggerId)) {
                        drawer.setAttribute('open', '');
                    }
                });
            });
        });

        backDrawerBtns.forEach((btn) => {
            const firstDrawerBtnId = btn.getAttribute('data-contain-first-id');
            const secondDrawerBtnId = btn.getAttribute('data-contain-second-id');

            btn.addEventListener('click', function (event) {
                event.preventDefault();

                drawers.forEach((drawer) => {
                    if (isMatchingDrawer(drawer, firstDrawerBtnId, secondDrawerBtnId)) {
                        drawer.removeAttribute('open');
                    }
                });
            });
        });
    }

    initMobileDrawer();

    /* === mobile-menu-drawer === E */

    /* === get header & announcement bar height === B */
    const announcementBar = document.querySelector('.announcement-bar');
    const headerWrapper = document.querySelector('.header-section--wrapper');

    function getVisibleHeight(element) {
        if (!element) {
            return 0;
        }

        const rect = element.getBoundingClientRect();
        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, window.innerHeight);

        return Math.max(0, visibleBottom - visibleTop);
    }

    function getHeaderHeight() {
        const announcementBarHeight = getVisibleHeight(announcementBar);
        const headerWrapperHeight = getVisibleHeight(headerWrapper);

        return announcementBarHeight + headerWrapperHeight;
    }

    function syncHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', getHeaderHeight() + 'px');
    }

    let headerHeightFrame;
    function scheduleHeaderHeightSync() {
        if (headerHeightFrame) return;
        headerHeightFrame = requestAnimationFrame(function () {
            headerHeightFrame = undefined;
            syncHeaderHeight();
        });
    }

    syncHeaderHeight();

    window.addEventListener('resize', function () {
        scheduleHeaderHeightSync();
    });

    window.addEventListener('scroll', function () {
        scheduleHeaderHeightSync();
    }, { passive: true });

    window.addEventListener('load', function () {
        scheduleHeaderHeightSync();
    });

    /* === get header & announcement bar height === E */

});
